import React from 'react';
import type { MenuLanguage } from '../main-menu/types.js';
import type { BotMatchResult } from '../../game/bot-match.js';
import './bot-match-results.css';

function formatMs(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function BotMatchResults({ result, language, onReplay, onMenu }: {
  result: BotMatchResult;
  language: MenuLanguage;
  onReplay: () => void;
  onMenu: () => void;
}) {
  const es = language === 'es';
  const tr = (spanish: string, english: string, french: string) =>
    es ? spanish : language === 'fr' ? french : english;

  return (
    <div className="bot-result-backdrop">
      <div className="bot-result-card">
        <div className={`bot-result-title${result.won ? ' is-win' : ''}`}>
          {result.won
            ? tr('¡VICTORIA!', 'VICTORY!', 'VICTOIRE !')
            : tr('ELIMINADO', 'ELIMINATED', 'ÉLIMINÉ')}
        </div>
        <div className="bot-result-placement">
          {tr('Posición', 'Placement', 'Position')}: <strong>#{result.placement}</strong>
          {' '}<span className="bot-result-muted">{tr('de', 'of', 'sur')} {result.totalPlayers}</span>
        </div>

        <div className="bot-result-stats">
          <div className="bot-result-stat">
            <span className="bot-result-stat__value">{result.eliminations}</span>
            <span className="bot-result-stat__label">{tr('Expulsiones', 'Eliminations', 'Éliminations')}</span>
          </div>
          <div className="bot-result-stat">
            <span className="bot-result-stat__value">{result.orbsCollected}</span>
            <span className="bot-result-stat__label">{tr('Orbes', 'Orbs', 'Orbes')}</span>
          </div>
          <div className="bot-result-stat">
            <span className="bot-result-stat__value">{formatMs(result.survivalMs)}</span>
            <span className="bot-result-stat__label">{tr('Sobrevivido', 'Survived', 'Survie')}</span>
          </div>
        </div>

        <button className="bot-result-button bot-result-button--primary" onClick={onReplay}>
          {tr('VOLVER A JUGAR', 'PLAY AGAIN', 'REJOUER')}
        </button>
        <button className="bot-result-button" onClick={onMenu}>
          {tr('VOLVER AL MENÚ', 'BACK TO MENU', 'RETOUR AU MENU')}
        </button>
      </div>
    </div>
  );
}